import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import App from "./App";
import "./index.css";
import store from "./store";
import { client } from "./apolloClient"; // Import Apollo Client instance

// Get the root DOM element
const container = document.getElementById("root");

// Use createRoot instead of ReactDOM.render
const root = createRoot(container);

// Wrap the App component with both ApolloProvider (for GraphQL) and Provider (for Redux)
root.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
    </Provider>
  </ApolloProvider>,
);
